/*eslint no-magic-numbers: 0*/
import React, { useCallback, useMemo, Fragment } from "react";
import { useSelector } from "react-redux";

import { getGraphSource } from "../../../../../../store/helpers/uiHelper";

import "./StressGraph.scss";

export const StressGraph = () => {
  const { report, questionAverages } = useSelector((state) => state.reports);
  const score = useMemo(() => (questionAverages ? questionAverages.si : null), [questionAverages]);

  const graphDate = useMemo(() => {
    return new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(report.date ? report.date : null));
  }, [report]);

  const renderGraph = useCallback(() => {
    return (
      <section className="render-graph">
        <img src={getGraphSource(score)} alt="Current score graph" className="score" />
        <p className="date">{report.date ? graphDate : null}</p>
      </section>
    );
  }, [score, report, graphDate]);

  return <Fragment>{renderGraph()}</Fragment>;
};
